import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, withModifiers as _withModifiers, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2e33336e"),n=n(),_popScopeId(),n)
const _hoisted_1 = ["data-cy"]
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "tw-absolute tw-right-0 tw-rounded-tr-[6px] tw-rounded-br-[6px] blurred" }, null, -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = {
  key: 0,
  class: "tw-text-[#B7B7B7] tw-text-[13px] tw-not-italic tw-font-[400] tw-leading-[normal]"
}
const _hoisted_5 = {
  key: 1,
  class: "tw-flex tw-gap-[5px] tw-min-w-[298px] tw-w-full tw-max-w-full lg:tw-max-w-[321px] tw-items-center tabWrapper"
}
const _hoisted_6 = { key: 2 }
const _hoisted_7 = {
  key: 0,
  class: "tw-text-[#231F20] tw-text-[13px] tw-not-italic tw-font-[500] tw-leading-[normal]"
}
const _hoisted_8 = { class: "tw-text-[#231F20] tw-text-[13px] tw-not-italic tw-font-[400] tw-leading-[normal]" }
const _hoisted_9 = { key: 1 }
const _hoisted_10 = {
  key: 0,
  class: "tw-text-[#B7B7B7] tw-text-[13px] tw-not-italic tw-font-[400] tw-leading-[normal]"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "tw-text-[#231F20] tw-text-[13px] tw-not-italic tw-font-[400] tw-leading-[normal]" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  xmlns: "http://www.w3.org/2000/svg",
  width: "10",
  height: "8",
  viewBox: "0 0 10 8",
  fill: "none"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M0.104884 2.00642L4.67976 7.19266C4.72096 7.23621 4.77061 7.2709 4.82567 7.2946C4.88073 7.31831 4.94005 7.33054 5 7.33054C5.05995 7.33054 5.11927 7.31831 5.17433 7.2946C5.22939 7.2709 5.27904 7.23621 5.32024 7.19266L9.89512 2.00642C9.93169 1.96522 9.95972 1.91717 9.97757 1.86505C9.99541 1.81293 10.0027 1.75778 9.99909 1.70281C9.99458 1.6474 9.97901 1.59345 9.95329 1.54417C9.92758 1.49488 9.89224 1.45124 9.84937 1.41584L9.07996 0.771202C9.03793 0.734847 8.98904 0.707283 8.93618 0.690139C8.88332 0.672995 8.82756 0.666619 8.77219 0.671387C8.71709 0.675373 8.66333 0.690299 8.61406 0.715292C8.56479 0.740285 8.52099 0.774843 8.48522 0.816951L5.0707 4.74718C5.04968 4.76801 5.02128 4.77969 4.99168 4.77969C4.96209 4.77969 4.93369 4.76801 4.91266 4.74718L1.51478 0.816951C1.44755 0.736646 1.35249 0.684663 1.2486 0.671387C1.19352 0.666053 1.13793 0.671766 1.08508 0.688192C1.03223 0.704618 0.983193 0.731424 0.940838 0.767043L0.150633 1.41584C0.107763 1.45124 0.0724248 1.49487 0.0467083 1.54417C0.0209918 1.59345 0.0054186 1.6474 0.000909419 1.70281C-0.00273159 1.75778 0.00458484 1.81293 0.0224338 1.86505C0.0402828 1.91717 0.0683087 1.96522 0.104884 2.00642Z",
    fill: "#387DFF"
  })
], -1))
const _hoisted_14 = [
  _hoisted_13
]
const _hoisted_15 = {
  key: 0,
  id: "search",
  class: "tw-flex tw-items-center tw-gap-[13px] tw-self-stretch tw-px-[26px] tw-py-[12px]"
}
const _hoisted_16 = /*#__PURE__*/_createStaticVNode("<svg xmlns=\"http://www.w3.org/2000/svg\" width=\"15\" height=\"15\" viewBox=\"0 0 15 15\" fill=\"none\" data-v-2e33336e><g clip-path=\"url(#clip0_8996_29950)\" data-v-2e33336e><path d=\"M8.34729 11.3435C11.2264 10.1199 12.5685 6.79401 11.3449 3.91489C10.1213 1.03576 6.79537 -0.306309 3.91624 0.91729C1.03712 2.14089 -0.304952 5.46681 0.918648 8.34593C2.14225 11.2251 5.46816 12.5671 8.34729 11.3435Z\" stroke=\"#B7B7B7\" stroke-width=\"0.9375\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-2e33336e></path><path d=\"M10.1367 10.1406L14.5298 14.5344\" stroke=\"#B7B7B7\" stroke-width=\"0.9375\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-2e33336e></path></g><defs data-v-2e33336e><clipPath id=\"clip0_8996_29950\" data-v-2e33336e><rect width=\"15\" height=\"15\" fill=\"white\" data-v-2e33336e></rect></clipPath></defs></svg>", 1)
const _hoisted_17 = ["placeholder"]

import { computed, onBeforeMount, onBeforeUnmount, ref, watch } from "vue";
import MutliLevelMutliSelectDropdownItem from "./mutliLevelMutliSelectDropdownItem.vue";
import TabletView from "./tabletView.vue";
import { DROPDOWN_TYPE } from "@/utils/constants";
import { generateSelectedItems, getComponentUiText } from "@/utils/utilities";
import { PropType } from "vue";
import { IMultiSelectDropdown } from "@/interfaces/common/IDropDown";


export default /*#__PURE__*/_defineComponent({
  __name: 'mutliLevelMutliSelectDropdown',
  props: {
  showDescription: {
    type: Boolean,
    required: false,
    default: false,
  },
  placeholder: {
    type: String,
    required: false,
    default: getComponentUiText(
      "app-menu-submenu-home-setup-wizard-modal-select-services-1",
    ),
  },
  searchPlaceholder: {
    type: String,
    required: false,
    default: getComponentUiText(
      "app-menu-submenu-home-setup-wizard-modal-services-question-placeholder-1",
    ),
  },
  data: {
    type: Object as PropType<IMultiSelectDropdown[]>,
    required: false,
    default: () => [] as IMultiSelectDropdown[],
  },
  type: {
    type: String,
    required: false,
    default: DROPDOWN_TYPE.MULTIPLE,
  },
  enableSearch: {
    type: Boolean,
    required: false,
    default: true,
  },
  modelValue: {
    type: String,
    required: false,
    default: "",
  },
  timeUpdated: {
    type: String,
    required: false,
    default: "false",
  },
  dropdownClass: {
    type: String,
    required: false,
    default: "",
  },
  mainWrapperClass: {
    type: String,
    required: false,
    default: "",
  },
  dataCyId: {
    type: String,
    required: false,
    default: "",
  },
},
  emits: [
  "update:selected",
  "update:child-selected",
  "update:modelValue",
  "update:store",
  "update:isDropdownOpen",
],
  setup(__props, { emit: emits }) {

const props = __props;





const isOpen = ref(false);
const dataShown: any = ref(props.data);
const searchValue = ref("");
const tabletContainer: any = ref(null);
const propsDataRef = ref(props.data);

const selectedItems = computed(() => {
  return props.type === DROPDOWN_TYPE.MULTIPLE
    ? generateSelectedItems(propsDataRef.value, "")
    : props.data.filter((item: any) => item.id === props.modelValue);
});

const itemSelected = computed(() => {
  let result: any = [];
  // props.data?.forEach(({ childData, ...item }: any) => {
  //   childData?.forEach((child: any) => {
  //     if (child.id === props.modelValue) {
  //       result = [...result, { ...child, ...item }];
  //     }
  //   });
  // });
  props.data?.forEach((item: any) => {
    if (item.id === props.modelValue) {
      result = [{ ...item }];
    }
  });
  return result;
});

watch(
  () => props.data,
  () => {
    dataShown.value = props.data;
  },
);

watch(
  () => isOpen.value,
  () => {
    emits("update:isDropdownOpen", isOpen.value);
  },
);

watch(
  () => props.timeUpdated,
  () => {
    dataShown.value = props.data;
    propsDataRef.value = props.data;
  },
);

watch(
  () => props.modelValue,
  () => {
    emits("update:selected", itemSelected);
  },
);

const isTitleSelected = (title: string) => {
  return selectedItems.value.some((item: any) => item.title === title);
};

const updateSelectItem = (
  dropdownData: IMultiSelectDropdown[],
  title: string,
) => {
  const updateSelected = (items: IMultiSelectDropdown[], title: string) => {
    for (let item of items) {
      if (item.title === title) item.selected = !item.selected;
      if (item.childData) updateSelected(item.childData, title);
    }

    return items;
  };

  return updateSelected(JSON.parse(JSON.stringify(dropdownData)), title);
};

const handleSelection = (title: string, parentTitle?: string, item?: any) => {
  let temp: IMultiSelectDropdown[] = [...propsDataRef.value];

  dataShown.value = propsDataRef.value = updateSelectItem(temp, title);
  const selectedItems = generateSelectedItems(propsDataRef.value, "");
  const data: IMultiSelectDropdown[] = selectedItems.map((e) => {
    return {
      ...e,
      name: e.parentTitle ? e.parentTitle + e.title : e.title,
      serviceTitle: e.title,
      serviceParentTitle: e.parentTitle || "",
      serviceTypeId: e.id || "",
    } as IMultiSelectDropdown;
  });

  // handle hide after single selected
  if (props.type === DROPDOWN_TYPE.SINGLE) isOpen.value = false;
  let id = null;
  if (itemSelected.value[0]?.id === item.id) {
    id = null;
  } else {
    id = item.id;
  }

  emits("update:modelValue", id || null, data);
  emits("update:store");
};

const handleSearch = (value: string) => {
  searchValue.value = value;
  dataShown.value = props.data.filter((item: any) => {
    return (
      item.title.toLowerCase().includes(value.toLowerCase()) ||
      item.childData?.some((itemC: any) =>
        itemC.title.toLowerCase().includes(value.toLowerCase()),
      )
    );
  });
};

onBeforeMount(() => {
  window.addEventListener("click", () => {
    isOpen.value = false;
  });
});

onBeforeUnmount(() => {
  window.removeEventListener("click", () => {
    isOpen.value = false;
  });
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(`tw-flex tw-flex-col tw-w-full tw-max-w-[380px] ${
      isOpen.value ? 'opened' : ''
    } mainWrapper ${__props.mainWrapperClass}`),
    onClick: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["stop"]))
  }, [
    _createElementVNode("div", {
      "data-cy": __props.dataCyId,
      onClick: _cache[2] || (_cache[2] = ($event: any) => (isOpen.value = !isOpen.value))
    }, [
      _renderSlot(_ctx.$slots, "buttonDropdown", {}, () => [
        _createElementVNode("div", {
          class: _normalizeClass(`tw-relative tw-h-[56px] tw-cursor-pointer tw-flex tw-justify-between tw-items-center tw-self-stretch tw-px-[20px] tw-py-[11px] tw-bg-[#F6F7F8] tw-w-full tw-rounded-t-[6px] ${
            isOpen.value ? '' : 'tw-rounded-b-[6px]'
          } dropdownButton`)
        }, [
          _hoisted_2,
          _createElementVNode("div", {
            ref_key: "tabletContainer",
            ref: tabletContainer,
            class: "tw-max-w-full tw-overflow-x-auto tw-overflow-y-hidden placeholder",
            onWheel: _cache[1] || (_cache[1] = 
              (e) => {
                if (!tabletContainer.value) return;
                tabletContainer.value.scrollLeft += e.deltaY;
              }
            )
          }, [
            (__props.type === _unref(DROPDOWN_TYPE).MULTIPLE)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                  (selectedItems.value.length <= 0)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_4, _toDisplayString(__props.placeholder), 1))
                    : (__props.type === _unref(DROPDOWN_TYPE).MULTIPLE)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(selectedItems.value, (item, index) => {
                            return (_openBlock(), _createBlock(TabletView, {
                              key: index,
                              "child-title": item.title,
                              "parent-title": item.parentTitle,
                              onClose: 
                    () => {
                      handleSelection(item.title, item.parentTitle, item);
                    }
                  ,
                              onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["stop"]))
                            }, null, 8, ["child-title", "parent-title", "onClose"]))
                          }), 128)),
                          _createVNode(TabletView, { class: "tw-invisible" })
                        ]))
                      : (_openBlock(), _createElementBlock("div", _hoisted_6, [
                          (selectedItems.value[0].parentTitle)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_7, _toDisplayString(selectedItems.value[0].parentTitle) + ": " + _toDisplayString(" "), 1))
                            : _createCommentVNode("", true),
                          _createElementVNode("span", _hoisted_8, _toDisplayString(selectedItems.value[0].title), 1)
                        ]))
                ]))
              : _createCommentVNode("", true),
            (__props.type === _unref(DROPDOWN_TYPE).SINGLE)
              ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                  (itemSelected.value.length <= 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_10, _toDisplayString(__props.placeholder), 1))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("span", _hoisted_12, _toDisplayString(itemSelected.value[0].name), 1)
                      ]))
                ]))
              : _createCommentVNode("", true)
          ], 544),
          _createElementVNode("span", {
            class: _normalizeClass(`tw-z-[1] arrowIcon ${isOpen.value ? 'rotated' : ''}`)
          }, _hoisted_14, 2)
        ], 2)
      ])
    ], 8, _hoisted_1),
    _createElementVNode("div", {
      class: _normalizeClass(`dropdownBody tw-flex tw-flex-col tw-rounded-bl-[6px] tw-rounded-br-[6px] tw-bg-white tw-max-h-[240px] !tw-overflow-y-auto ${__props.dropdownClass}`)
    }, [
      (__props.enableSearch)
        ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
            _hoisted_16,
            _createElementVNode("input", {
              type: "text",
              class: "tw-border-none tw-w-full searchInput",
              placeholder: __props.searchPlaceholder,
              onInput: _cache[3] || (_cache[3] = (e) => handleSearch(e?.target?.value))
            }, null, 40, _hoisted_17)
          ]))
        : _createCommentVNode("", true),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dataShown.value, (item, index) => {
        return (_openBlock(), _createBlock(MutliLevelMutliSelectDropdownItem, {
          key: index,
          title: item.title,
          "item-description": __props.showDescription ? item.templateDescription : '',
          "child-data": item.childData,
          selected: isTitleSelected(item.title),
          "selected-items": selectedItems.value,
          "data-cy": "mutliLevelMutliSelectDropdownItemLevel-1",
          type: __props.type,
          "search-value": searchValue.value,
          "is-toggle": item.isToggle,
          "onUpdate:selected": 
          () => {
            handleSelection(item.title, undefined, item);
          }
        ,
          "onUpdate:childSelected": 
          (itemChildData) => {
            handleSelection(itemChildData.title, item.title, itemChildData);
          }
        
        }, null, 8, ["title", "item-description", "child-data", "selected", "selected-items", "type", "search-value", "is-toggle", "onUpdate:selected", "onUpdate:childSelected"]))
      }), 128))
    ], 2)
  ], 2))
}
}

})